import React from 'react';
import { useNavigate } from 'react-router-dom';

const FavoritesPage = ({ setSelectedPiece, favorites = [], removeFavorite }) => {
  const navigate = useNavigate();

  const handlePieceClick = (piece) => {
    setSelectedPiece(piece);
    navigate('/piece');
  };

  return (
    <div className="home-page">
      <section className="results-section results-section--focused">
        <div className="results-header">
          <div>
            <h2 className="results-title">Your favorites</h2>
            <p className="results-subtitle">Pieces you've favorited for quick access.</p>
          </div>
          <span className="results-count">{favorites.length} item{favorites.length === 1 ? '' : 's'}</span>
        </div>

        <div className="pieces-container">
          {favorites.length === 0 ? (
            <div className="empty-state">
              <h3 className="empty-title">No favorites yet</h3>
              <p className="empty-description">Click the heart on a piece to save it here.</p>
            </div>
          ) : (
            favorites.map((piece, index) => (
              <div key={`${piece.id || piece.title}-${index}`} className="piece-box" role="button" tabIndex={0} onClick={() => handlePieceClick(piece)}>
                <div className="piece-box__header">
                  <span className="piece-box__badge">{piece.composer || 'Unknown'}</span>
                </div>
                <h3 className="piece-box__title">{piece.title}</h3>
                <p className="piece-box__meta">{piece.instruments?.join(', ') || 'Unknown instrument'}</p>
                <div style={{marginTop:8}}>
                  <button className="secondary" onClick={(e) => { e.stopPropagation(); removeFavorite(piece); }}>Remove</button>
                </div>
              </div>
            ))
          )}
        </div>
      </section>
    </div>
  );
};

export default FavoritesPage;
